export const getElementOnShadowRoot = (host, element) => {
  const shadowRoot = getShadowRoot(host)
  if (shadowRoot) {
    return shadowRoot.querySelector(element)
  }
}

export const getShadowRoot = (host) => {
  const hostElement = document.querySelector(host)
  return hostElement?.shadowRoot
}
